<ng-container *ngIf="form" [formGroup]="form">
  <div class="grid p-fluid">
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="name" pInputText formControlName="name"> 
              <label [ngClass]="{'required': form.get('name')?.hasValidator(validators.required)}" for="name">Nome Completo</label>
          </span>
          <split-control-errors [control]="form.get('name')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="monthlyIncomeManager" prefix="R$ " [allowNegativeNumbers]="false" mask="separator.2" thousandSeparator="." decimalMarker=","  pInputText formControlName="monthlyIncomeManager"> 
              <label [ngClass]="{'required': form.get('monthlyIncomeManager')?.hasValidator(validators.required)}" for="monthlyIncomeManager">Receita Mensal</label>
          </span>
          <split-control-errors [control]="form.get('monthlyIncomeManager')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="taxId" pInputText formControlName="taxId" mask="000.000.000-00"> 
              <label [ngClass]="{'required': form.get('taxId')?.hasValidator(validators.required)}" for="taxId">CPF</label>
          </span>
          <small *ngIf="form.get('taxId')?.errors?.['taxId']" class="p-error">
              O CPF informado é inválido
          </small>
          <split-control-errors [control]="form.get('taxId')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
            <span class="p-float-label ">
              <input type="text" id="birthdate" pInputText formControlName="birthdate" mask="00/00/0000" [dropSpecialCharacters]="false"> 
              <label [ngClass]="{'required': form.get('birthdate')?.hasValidator(validators.required)}"  for="birthdate">Data de Nascimento</label>
          </span>
          <split-control-errors [control]="form.get('birthdate')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="emailProfessional" pInputText formControlName="emailProfessional"> 
              <label [ngClass]="{'required': form.get('emailProfessional')?.hasValidator(validators.required)}" for="emailProfessional">Email</label>
          </span>
          <split-control-errors [control]="form.get('emailProfessional')"></split-control-errors>
      </div>
      <div class="field col-12 md:col-6">
          <span class="p-float-label">
              <input type="text" id="contactNumber" pInputText formControlName="contactNumber" mask="(00) 00000-0000||(00) 0000-0000"> 
              <label [ngClass]="{'required': form.get('contactNumber')?.hasValidator(validators.required)}" for="contactNumber">Celular</label>
          </span>
          <split-control-errors [control]="form.get('contactNumber')"></split-control-errors>
      </div>
      <div class="field col-12">
        <split-address-form formGroupName="address"></split-address-form>
      </div>
  </div>
</ng-container>